import React from 'react';
import './MenuItem.css';

function MenuItem({ children, onClick, isActive, icon }) {
  return (
    <button className={`menu-item text-non-selectable ${isActive ? 'menu-item-active' : ''}`} onClick={onClick}>
      {icon && <span className="menu-item-icon">{icon}</span>}
      <span className="menu-item-label">{children}</span>
      {isActive && (
        <span className="menu-item-checkmark">
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
            <path d="M3 8 L6 11 L13 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      )}
    </button>
  );
}

export default MenuItem;

